import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { CartDrawer } from "@/components/CartDrawer";
import { MobileActionBar } from "@/components/MobileActionBar";

import Landing from "@/pages/Landing";
import Join from "@/pages/Join";
import Donate from "@/pages/Donate";
import DonateRedirect from "@/pages/DonateRedirect";
import DonationSuccess from "@/pages/DonationSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { MemberLogin, MemberSignup } from "@/pages/MemberAuth";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import MemberAccount from "@/pages/MemberAccount";
import About from "@/pages/About";
import Founder from "@/pages/Founder";
import Events from "@/pages/Events";
import Divisions from "@/pages/Divisions";
import DivisionDetail from "@/pages/DivisionDetail";
import Media from "@/pages/Media";
import Schools from "@/pages/Schools";
import Store from "@/pages/Store";
import Forum from "@/pages/Forum";
import StartChapter from "@/pages/StartChapter";
import Chapters from "@/pages/Chapters";
import ChapterPage from "@/pages/ChapterPage";
import StoreSuccess from "@/pages/StoreSuccess";

function ProtectedRoute({ children, requireAdmin }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center font-display text-2xl">LOADING…</div>;
  if (!user) return <Navigate to={requireAdmin ? "/admin/login" : "/login"} replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/account" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/about" element={<About />} />
              <Route path="/divisions" element={<Divisions />} />
              <Route path="/divisions/:slug" element={<DivisionDetail />} />
              <Route path="/founder" element={<Founder />} />
              <Route path="/events" element={<Events />} />
              <Route path="/media" element={<Media />} />
              <Route path="/schools" element={<Schools />} />
              <Route path="/store" element={<Store />} />
              <Route path="/forum" element={<Forum />} />
              <Route path="/store/success" element={<StoreSuccess />} />
              <Route path="/join" element={<Join />} />
              <Route path="/start-a-chapter" element={<StartChapter />} />
              <Route path="/chapters" element={<Chapters />} />
              <Route path="/chapter/:slug" element={<ChapterPage />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/give" element={<DonateRedirect />} />
              <Route path="/donation/success" element={<DonationSuccess />} />
              <Route path="/login" element={<MemberLogin />} />
              <Route path="/signup" element={<MemberSignup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/account" element={<ProtectedRoute><MemberAccount /></ProtectedRoute>} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <CartDrawer />
            <MobileActionBar />
          </BrowserRouter>
          <Toaster position="bottom-right" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
